module.exports = __webpack_public_path__ + "static/img/img_guide_08.6ebb4ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_guide_08.jpg
// module id = 220
// module chunks = 1